/* eslint-disable @typescript-eslint/no-unused-vars */
import { CSSProperties, useEffect, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import { useParams } from "react-router-dom";
import { useGetCustomerById } from "../../api/customer";
import {
  Button,
  Card,
  Checkbox,
  Image,
  Input,
  message,
  Table,
  Tabs,
  Typography,
} from "antd";

import img from "../../assets/images/user.png";
import female from "../../assets/images/user-female.png";
import pdfIcon from "../../assets/images/pdf.png";

import {
  GoogleMap,
  InfoWindow,
  MarkerF,
  useLoadScript,
} from "@react-google-maps/api";
import { DownloadOutlined } from "@ant-design/icons";
import FileUploadDropdown from "../../components/FileUploadDropdown";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import {
  useUploadDocument,
  useGetNonContractFarmerLoanById,
} from "../../api/customer";
import LoadingScreen from "../../components/LoadingScreen";
import { useApproveRejectNonContractFarmerLoan } from "../../api/customer";
import type { FarmerBankAccountRow } from "../../types/customer";
export interface IAddress {
  landCode: string;
  landSize: number;
  latitude: number;
  longitude: number;
  region: string;
  zone: string;
  woreda: string;
  kebele: string;
  unionName: string;
  primaryCooperativeName: string;
}

const wrapper: CSSProperties = {
  display: "flex",
  width: "100%",
  // gap: 10,
  fontSize: 16,
  // marginBottom: 20,
  flexDirection: "column",
};
const label: CSSProperties = {
  color: "#128807",
  fontWeight: 500,
  fontSize: 20,
  marginBottom: 10,
};
const value: CSSProperties = {
  color: "#8590A3",
  fontWeight: 500,
  fontSize: 16,
};

const CustomerDetailPage = () => {
  const { id } = useParams();
  const {
    data: customer,
    refetch,
    isLoading: customerLoading,
  } = useGetCustomerById(id);
  const {
    mutateAsync: uploadDocument,
    isSuccess,
    isPending,
  } = useUploadDocument();

  const { data: loanDetailData, isLoading: loanLoading } =
    useGetNonContractFarmerLoanById(customer?.data?.data?.customer?.id);

  const { mutate: approveRejectLoan, isPending: loanApprovalSubmitting } =
    useApproveRejectNonContractFarmerLoan();
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [narration, setNarration] = useState("");
  const [creditScore, setCreditScore] = useState<number>(0);
  const [bankVerification, setBankVerification] = useState(false);
  const { Text } = Typography;

  const [mapView, setMapView] = useState<boolean>(false);
  const [photo, setPhoto] = useState("");
  const [documents, setDocuments] = useState<
    { docId: number; file: string; fileName: string; fileType: string }[]
  >([]);
  const [farmLands, setFarmLands] = useState<IAddress[]>([]);
  const [farmerAddress, setFarmerAddress] = useState<{
    region: string;
    zone: string;
    woreda: string;
    kebele: string;
    houseNo: string;
  }>();
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBG4pD21Xf2Mqq0kMUo2POHq_UrHooGQ18",
  });
  const [activeMarker, setActiveMarker] = useState("");
  const { user } = useAuth() as AuthContextValue;
  const [role, setRole] = useState<"ROLE_KFT_SP_ADMIN" | undefined>();
  const [activeTab, setActiveTab] = useState("1");
  const farmerAccounts: FarmerBankAccountRow[] = Array.isArray(
    customer?.data?.data?.customer?.bankAccounts
  )
    ? customer?.data?.data?.customer?.bankAccounts
    : [];

  useEffect(() => {
    if (user?.roleName === "ROLE_KFT_SP_ADMIN") {
      setRole("ROLE_KFT_SP_ADMIN");
    } else {
      setRole(undefined);
    }
  }, [user]);

  useEffect(() => {
    if (customer) {
      if (
        customer &&
        customer.data &&
        customer.data.data &&
        customer.data.data.farmerDocuments
      ) {
        const _photo = customer.data.data.farmerDocuments.find(
          (item: any) => item.fileName.toLowerCase().indexOf("photo") > -1
        );
        if (_photo) {
          setPhoto(_photo.file);
        }

        const _documents = customer.data.data.farmerDocuments.filter(
          (item: any) => !item.fileName.startsWith("photo")
        );

        if (_documents) {
          const d = _documents.map((item: any) => {
            return {
              docId: item.docId,
              file: item.file,
              fileName: item.fileName,
              fileType: item.fileType,
            };
          });

          setDocuments(d);
        }
      }

      if (customer.data.data.customer.address) {
        const _farmerAddress = JSON.parse(customer.data.data.customer.address);

        if (_farmerAddress) {
          setFarmerAddress(_farmerAddress);
        }
      }

      const address = customer.data.data.farmLand.map((item: any) => {
        const land = {
          latitude: item.latitude,
          longitude: item.longitude,
          landCode: item.landCode,
          landSize: item.landSize,
        };

        if (item.address) {
          const _address = JSON.parse(item.address);
          const _land = {
            ...land,
            region: _address.region,
            woreda: _address.woreda,
            zone: _address.zone,
            kebele: _address.kebele,
            unionName: _address.unionName,
            primaryCooperativeName: _address?.primaryCooperativeName,
          };

          return _land;
        }

        return land;
      });

      setFarmLands(address);
    }
  }, [customer]);

  const handleOnLoad = (map: any) => {
    const bounds = new google.maps.LatLngBounds();
    map.fitBounds(bounds);
  };

  const handleActiveMarker = (landCode: string) => {
    if (landCode === activeMarker) {
      return;
    }
    setActiveMarker(landCode);
  };

  const handleFileUpload = async (files: File[], documentType: string) => {
    const token = user?.token;
    const uuid = customer?.data?.data?.customer?.uuid || crypto.randomUUID();
    if (!token || !uuid) {
      console.error("Missing authentication details or UUID.");
      return;
    }

    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    formData.append("uuid", uuid);

    uploadDocument(formData, {
      onSuccess: () => {
        refetch();
      },
      onError: (error) => {
        console.error("File upload error:", error);
      },
    });
  };

  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id]);

  const handleNoncontractfarmerLoan = (status: number) => {
    if (status === 1) {
      setApproveLoading(true);
    } else {
      setRejectLoading(true);
    }

    const primaryAccount =
      farmerAccounts.find((a) => a?.isPrimary && a?.isActive !== false) ||
      farmerAccounts.find((a) => a?.isActive !== false) ||
      farmerAccounts[0];
    const bankAccount = primaryAccount?.accountNumber;
    const bankAccountName = primaryAccount?.accountName || primaryAccount?.bankName;

    if (!bankAccount || !bankAccountName) {
      message.error("Farmer account details are missing.");
      return;
    }

    approveRejectLoan(
      {
        ...loanDetailData?.data,
        creditscore: creditScore,
        bankVerification,
        status,
        narration,
        bankAccount,
        bankAccountName,
      },
      {
        onSuccess: () => {
          message.success("Non Contract Farmer loan submitted successfully!");
          setApproveLoading(false);
          setRejectLoading(false);
          setNarration("");
          setCreditScore(0);
          setBankVerification(false);
        },
        onError: (error) => {
          message.error("Error submitting Non Contract Farmer loan");
          setApproveLoading(false);
          setRejectLoading(false);
          setNarration("");
          setCreditScore(0);
          setBankVerification(false);
        },
      }
    );
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
      render: (text: string) => text?.split(".")[0],
    },
    {
      title: "File Type",
      dataIndex: "fileType",
      key: "fileType",
    },
    {
      title: "Preview",
      dataIndex: "preview",
      key: "preview",
      render: (text: any, record: any) =>
        record.fileType?.includes("pdf") ? (
          <Image preview={false} src={pdfIcon} width={50} height={50} />
        ) : (
          <Image
            src={`data:image/jpeg;base64,${record.file}`}
            height={50}
            width={50}
          />
        ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text: any, record: any) => (
        <Button
          type="link"
          icon={<DownloadOutlined />}
          href={`data:application/pdf;base64,${record.file}`}
          download={`${customer?.data?.data?.customer?.fullName}-${
            record.fileName.split(".")[0]
          }`}
        />
      ),
    },
  ];

  const loanContent = (
    <div className="flex w-full mb-6 gap-6">
      <div className="bg-white rounded-lg shadow-md p-4 flex items-center justify-center w-1/3">
        {loanDetailData?.data ? (
          <div className="grid grid-cols-2 md:grid-cols-1 gap-4 text-sm">
            {[
              {
                label: "Customer Name",
                value: loanDetailData.data.customerName,
              },
              { label: "Product Name", value: loanDetailData.data.productName },
              { label: "Credit Score", value: loanDetailData.data.creditScore },
            ].map((item, index) => (
              <div key={index}>
                <div style={label}>{item.label}</div>
                <div style={value}>{item.value || "N/A"}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-6 text-gray-500">
            No loan details found.
          </div>
        )}
      </div>

      <div className="bg-white rounded-lg shadow-md p-6 w-2/3">
        {loanLoading ? (
          <div className="text-center py-6 text-gray-500">
            Loading loan details...
          </div>
        ) : loanDetailData?.data ? (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
              {[
                {
                  label: "Purpose of Loan",
                  value: loanDetailData.data.purposeOfLoan,
                },
                {
                  label: "Product Name",
                  value: loanDetailData.data.productName,
                },
                {
                  label: "Msm classification",
                  value: `${loanDetailData.data.msmClassification}`,
                },

                {
                  label: "Interest Rate (%)",
                  value: `${loanDetailData.data.interest}%`,
                },
                {
                  label: "Interest Application",
                  value: `${loanDetailData.data.interestApplication}`,
                },
                {
                  label: "Tenure Months",
                  value: `${loanDetailData.data.returnMonth}`,
                },
                {
                  label: "Grace Period Months",
                  value: `${loanDetailData.data.gracePeriodMonths}`,
                },
                {
                  label: "Minimum Loan Limit (ETB)",
                  value: loanDetailData.data.minimumLoanLimit?.toLocaleString(
                    "en-ET",
                    {
                      style: "currency",
                      currency: "ETB",
                    }
                  ),
                },
                {
                  label: "Maximum Loan Limit (ETB)",
                  value: loanDetailData.data.maximumLoanLimit?.toLocaleString(
                    "en-ET",
                    {
                      style: "currency",
                      currency: "ETB",
                    }
                  ),
                },
                {
                  label: "Bank Verification",
                  value: loanDetailData.data.bankVerification
                    ? loanDetailData.data.bankVerification
                    : "PENDING",
                },
              ].map((item, index) => (
                <div key={index}>
                  <div style={label}>{item.label}</div>
                  <div style={value}>{item.value || "N/A"}</div>
                </div>
              ))}
            </div>

            {/* Loan Approval & KYC Verification */}
            {user?.roleName !== "ROLE_KFT_SP_ADMIN" &&
              user?.roleName !== "ROLE_KFT_SUPER_ADMIN" && (
                <Card className="flex flex-col text-black mb-4 bg-transparent mt-4">
                  <div className="flex flex-col gap-2  p-4 rounded-lg font-medium text-lg mb-4">
                    <h2 className="text-gray-500 font-semi-bold mb-4">
                      Loan Approval & KYC Verification{" "}
                    </h2>

                    <Checkbox
                      checked={bankVerification}
                      onChange={(e) => setBankVerification(e.target.checked)}
                    >
                      <span className="text-gray-500 font-normal">Verify</span>
                    </Checkbox>
                    <span className="text-gray-500 font-normal">Narration</span>
                    <Input
                      placeholder="Enter narration"
                      className="w-full md:w-1/2 font-normal"
                      value={narration}
                      onChange={(e) => setNarration(e.target.value)}
                    />
                    <span className="text-gray-500 font-normal">
                      Credit Score
                    </span>
                    <Input
                      placeholder="Enter credit score"
                      className="w-full md:w-1/2 font-normal"
                      value={creditScore}
                      onChange={(e) => setCreditScore(Number(e.target.value))}
                    />
                  </div>

                  <div className="flex gap-4 mt-4 justify-end">
                    <Button
                      type="primary"
                      loading={approveLoading}
                      onClick={() => handleNoncontractfarmerLoan(1)}
                      disabled={!narration.trim() || approveLoading}
                    >
                      Approve
                    </Button>
                    <Button
                      type="default"
                      danger
                      loading={rejectLoading}
                      onClick={() => handleNoncontractfarmerLoan(0)}
                      disabled={!narration.trim() || rejectLoading}
                    >
                      Reject
                    </Button>
                  </div>
                </Card>
              )}
          </>
        ) : (
          <div className="text-center py-6 text-gray-500">
            No loan details found.
          </div>
        )}
      </div>
    </div>
  );

  const tabItems = [
    {
      key: "1",
      label: "CUSTOMER DETAILS",
      children: (
        <div className="flex w-full mb-[25px] gap-6">
          {/* Left side: Customer photo card */}
          <div className="bg-white rounded-lg shadow-md p-4 flex items-center justify-center w-1/3">
            {photo ? (
              <Image
                src={`data:image/jpeg;base64,${photo}`}
                height={150}
                width={150}
                className="rounded-full"
                alt="Customer"
              />
            ) : (
              <Image
                src={
                  customer?.data?.data?.customer?.gender === "Female"
                    ? female
                    : img
                }
                height={150}
                width={150}
                className="rounded-full"
                alt="Default Profile"
              />
            )}
          </div>

          {/* Right side: Customer details */}
          <div className="bg-white rounded-lg shadow-md p-6 w-2/3">
            <div className="bg-gray-200 p-4 rounded-lg font-medium text-lg mb-4">
              Customer Detail
            </div>
            <div className="grid grid-cols-3 gap-4">
              {[
                {
                  label: "Full Name",
                  value: customer?.data?.data?.customer?.fullName,
                },
                {
                  label: "Gender",
                  value: customer?.data?.data?.customer?.gender,
                },
                {
                  label: "Phone No.",
                  value: customer?.data?.data?.customer?.phoneNumber,
                },
                {
                  label: "Customer ID",
                  value: customer?.data?.data?.customer?.customerId,
                },
                {
                  label: "TIN",
                  value: customer?.data?.data?.customer?.tinNumber,
                },
                {
                  label: "Spouse's TIN",
                  value: customer?.data?.data?.customer?.spouseTinNo,
                },
                {
                  label: "Marital Status",
                  value: customer?.data?.data?.customer?.maritalStatus,
                },
                {
                  label: "Primary Cooperative Name",
                  value:
                    customer?.data?.data?.customer?.primaryCooperativeName ||
                    "N/A",
                },
                {
                  label: "Union Name",
                  value: customer?.data?.data?.customer?.unionName || "N/A",
                },
              ].map((item, index) => (
                <div key={index}>
                  <div style={label}>{item.label}</div>
                  <div style={value}>{item.value}</div>
                </div>
              ))}
            </div>

            <div className="bg-gray-200 p-4 rounded-lg font-medium text-lg mt-6 mb-4">
              Farmer Accounts
            </div>
            {farmerAccounts.length === 0 ? (
              <div className="text-gray-500">No farmer accounts found.</div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {farmerAccounts.map((acc) => (
                  <div
                    key={acc.id}
                    className="rounded-lg border border-gray-200 bg-white p-3"
                  >
                    <div className="font-semibold text-gray-800">
                      {acc.bankName || "Bank"}
                      {acc.isPrimary ? (
                        <span className="ml-2 text-xs text-blue-600 font-normal">
                          (primary)
                        </span>
                      ) : null}
                    </div>
                    <div className="text-sm text-gray-700 mt-1 font-mono break-all">
                      {acc.accountNumber || "N/A"}
                    </div>
                    <div className="text-xs text-gray-500 mt-2">
                      KYC: {acc.kycStatus || "N/A"}
                    </div>
                    {acc.accountName ? (
                      <div className="text-xs text-gray-500 mt-1">
                        Account name: {acc.accountName}
                      </div>
                    ) : null}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "FARM LOCATION",
      children: (
        <div className="rounded-xl overflow-hidden mt-4 pt-2">
          <div className="flex justify-between pl-2">
            {/* <Switch
              checkedChildren="Text View"
              unCheckedChildren="Map View"
              defaultChecked
              onChange={(val: any) => setMapView(val)}
            /> */}
            {/* <Button
              type="primary"
              onClick={() =>
              
                openMapInNewTab(farmLands[0]?.latitude, farmLands[0]?.longitude)
              }
              style={{ marginTop: 10 }}
            >
              Open in Google Maps
            </Button> */}
          </div>
          {isLoaded && (
            <GoogleMap
              onLoad={handleOnLoad}
              mapContainerClassName={`w-full min-h-[500px] rounded-xl ${
                mapView ? "block" : "hidden"
              }`}
              center={{
                lat: farmLands[0]?.latitude,
                lng: farmLands[0]?.longitude,
              }}
              zoom={15}
            >
              {farmLands &&
                farmLands.map((_data: IAddress) => {
                  if (_data.landCode) {
                    return (
                      <MarkerF
                        key={`${_data.landCode}-${_data.latitude}-${_data.longitude}`}
                        position={{
                          lat: _data.latitude,
                          lng: _data.longitude,
                        }}
                        onClick={() => handleActiveMarker(`${_data.landCode}`)}
                      >
                        {activeMarker === _data.landCode ? (
                          <InfoWindow
                            options={{
                              zIndex: 9999,
                              maxWidth: 400,
                            }}
                            position={{
                              lat: _data.latitude,
                              lng: _data.longitude,
                            }}
                            onCloseClick={() => setActiveMarker("")}
                          >
                            <FarmLandCard
                              key={_data.landCode}
                              region={_data.region}
                              zone={_data.zone}
                              woreda={_data.woreda}
                              kebele={_data.kebele}
                              landSize={_data.landSize}
                            />
                          </InfoWindow>
                        ) : null}
                      </MarkerF>
                    );
                  } else {
                    return <div></div>;
                  }
                })}
            </GoogleMap>
          )}
          {!mapView && (
            <div
              className={`flex flex-col justify-start min-h-[500px] bg-white p-[15px] rounded-xl mt-7.5`}
            >
              {farmLands.map((item: IAddress, index: number) => (
                <>
                  <div
                    key={index}
                    className={`bg-[#E9EDF4] p-[15px] rounded-xl ${
                      index === 0 ? "mb-[30px]" : "mt-4 mb-[30px]"
                    }`}
                    style={{
                      fontWeight: 500,
                      fontSize: "24px",
                    }}
                  >
                    Address - {index + 1}
                  </div>
                  <div className="flex flex-col md:flex-row flex-wrap md:gap-6 pl-5">
                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>Region</div>
                      <div style={value}>{item.region || "N/A"}</div>
                    </div>

                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>Zone</div>
                      <div style={value}>{item.zone || "N/A"}</div>
                    </div>

                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>Woreda</div>
                      <div style={value}>{item.woreda || "N/A"}</div>
                    </div>

                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>Kebele</div>
                      <div style={value}>{item.kebele || "N/A"}</div>
                    </div>

                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>Land size</div>
                      <div style={value}>{`${item.landSize} ha` || "N/A"}</div>
                    </div>

                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>PC</div>
                      <div style={value}>
                        {item.primaryCooperativeName || "N/A"}
                      </div>
                    </div>

                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>Union</div>
                      <div style={value}>{item.unionName || "N/A"}</div>
                    </div>

                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>Latitude</div>
                      <div style={value}>{item.latitude || "N/A"}</div>
                    </div>

                    <div
                      className="flex flex-row justify-between md:gap-[10px] border-b-2 md:border-b-0 md:flex-col w-auto"
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      <div style={label}>Longitude</div>
                      <div style={value}>{item.longitude || "N/A"}</div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          )}
        </div>
      ),
    },
    {
      key: "3",
      label: "LEGAL DOCUMENTS",
      children: (
        <div>
          {customer && !customerLoading && (
            <div
              style={{
                fontFamily: "Poppins",
                padding: 20,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                borderRadius: 8.5,
                backgroundColor: "white",
              }}
            >
              <div className="flex w-full mb-[25px]">
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: 700,
                      borderRadius: "8.5px",
                      backgroundColor: "white",
                      paddingTop: "33px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#E9EDF4",
                        padding: "15px",
                        borderRadius: "8.5px",
                        fontWeight: 500,
                        fontSize: "24px",
                        marginBottom: "30px",
                      }}
                    >
                      Legal documents
                    </div>
                    {role === "ROLE_KFT_SP_ADMIN" && (
                      <FileUploadDropdown
                        handleFileUpload={handleFileUpload}
                        isLoading={isPending}
                      />
                    )}

                    <Table
                      columns={columns}
                      dataSource={documents || []}
                      rowKey="docId"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      key: "4",
      label: "LOAN DETAILS",
      children: (
        <>
          {customer && !customerLoading ? (
            <div className="p-5 flex flex-col items-center rounded-xl bg-white font-poppins">
              <div className="w-full mb-6">
                <div className="bg-white pt-8 rounded-xl font-bold">
                  <div className="bg-gray-100 p-4 rounded-xl text-2xl font-medium mb-6">
                    Loan Details
                  </div>
                  {loanContent ?? (
                    <div className="text-center text-gray-500 py-4">
                      No loan data available.
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="p-5 text-center text-gray-500 font-poppins">
              {customerLoading
                ? "Loading loan details..."
                : "No customer selected."}
            </div>
          )}
        </>
      ),
    },
  ];

  const openMapInNewTab = (lat: number, lng: number) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(googleMapsUrl, "_blank");
  };

  const handleRemoveDocument = (docId: string) => {
    setDocuments([]);
  };

  const handleUpload = (file: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const result = reader.result;

      if (typeof result === "string") {
        const base64File = result.split(",")[1];

        const newDocument = {
          docId: new Date().getTime().toString(),
          file: base64File,
          fileName: file.name,
          fileType: file.type,
        };

        setDocuments([newDocument as any]);
      } else {
        console.error(
          "FileReader result is not a string, unable to process file."
        );
      }
    };

    return false;
  };

  if (customerLoading || isPending) return <LoadingScreen />;

  return (
    <Tabs
      style={{
        background: "white",
        fontWeight: 700,
        paddingLeft: 20,
        marginTop: 20,
      }}
      className="text-black"
      defaultActiveKey="1"
      items={tabItems}
      onChange={(key) => setActiveTab(key)}
    />
  );
};

export const FarmLandCard = ({
  region,
  zone,
  woreda,
  kebele,
  landSize,
}: {
  region: string;
  zone: string;
  woreda: string;
  kebele: string;
  landSize: number;
}) => {
  return (
    <div className="w-[300px] flex flex-row gap-2">
      <div className="flex flex-col w-[600px] gap-2">
        <div className="flex gap-8">
          <div className="px-2 w-full flex flex-col gap-4 text-lg">
            <div className="flex justify-between border-b-2 border-dashed border-gray-400">
              <div className="font-semibold text-gray-400">Region</div>
              <div className="font-bold">{region}</div>
            </div>
            <div className="flex justify-between border-b-2 border-dashed border-gray-400">
              <div className="font-semibold text-gray-400">Zone</div>
              <div className="font-bold">{zone}</div>
            </div>
            <div className="flex justify-between border-b-2 border-dashed border-gray-400">
              <div className="font-semibold text-gray-400">Woreda</div>
              <div className="font-bold">{woreda}</div>
            </div>
            <div className="flex justify-between border-b-2 border-dashed border-gray-400">
              <div className="font-semibold text-gray-400">Kebele</div>
              <div className="font-bold">{kebele}</div>
            </div>
            <div className="flex justify-between border-b-2 border-dashed border-gray-400">
              <div className="font-semibold text-gray-400">Land Size</div>
              <div className="font-bold">{landSize} ha</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithAuth(CustomerDetailPage);
